export default __webpack_public_path__ + "static/media/Baobab_MCF_Logo_FullColor.1f8e76f9.svg";